import { caseDiagnosisRecord, getJGList, getSystemTime, getDictTypeTree, consumeMessage, getPayWay, getDiagnoses, saveLog, getOption,getSourceConfig } from '@/api/common';
import { deptList } from '@/api/hospital'
import _, { isEmpty } from 'lodash';
import moment from 'moment';
import { PAY_WAY } from '@/utils/const'
import { isNull } from '@/utils/validateBase'
import session from '@/utils/session'; // 获取本地存储
import { SystemTime } from '@/config/systemTime'
class CommonDTO {

  /**
   * 获取诊断操作记录
   */
  static caseDiagnosisRecordDTO(params) {
    return new Promise((resolve, reject) => {
      caseDiagnosisRecord(params).then(res => {
        resolve(res)
      })
    })
  }
  /**
   * 获取加工费列表
   */
  static getJGList(params) {
    return new Promise((resolve, reject) => {
      getJGList(params).then(res => {
        resolve(res)
      })
    })
  }
  /**
   * 获取系统时间
   */
  static getSystemTimeDTO() {
    return Number(SystemTime.getCorrect())
    // return new Promise((resolve, reject) => {
    //     getSystemTime().then(res => {
    //         if (res.code == 200) {
    //             resolve(res.data.date_local)
    //         } else {
    //             resolve(new Date())
    //         }
    //     })
    // })
  }
  static startOfDay(time) {
    return _.toString(moment(time).startOf('day'))
  }

  static endOfDay(time) {

    return _.toString(moment(time).endOf('day'))
  }
  static timeFormat(time) {
    return _.toString(moment(time).format('yyyy-MM-DD'))
  }
  static timeFormatMM(time) {
    return _.toString(moment(time).format('MM-DD'))
  }
  /**
   * 获取字典类型
   */
  static getDictTypeTreeDTO(type) {
    let obj = {
      level: { dictType: 'goods_level' }, //获取分类
    }
    return new Promise((resolve, reject) => {
      getDictTypeTree(obj[type]).then(res => {
        resolve(res)
      })
    })
  }
  //获取消费消息
  static consumeMessage(obj) {
    return new Promise((resolve, reject) => {
      consumeMessage(obj).then(res => {
        resolve(res)
      }).catch(err => {
        reject()
      })
    })
  }
  /**
   * 获取支付方式
   */
  static getPayWay(params) {
    return new Promise((resolve, reject) => {
      if (isNull(session.get('PAY_WAY'))) {
        getPayWay(params).then(res => {
          if (res.code == 200) {
            let list = []
            res.data && res.data.forEach(item => {
              list.push({
                label: item.name,
                value: item.code,
                icon: item.icon
              })
            })
            session.set('PAY_WAY', list)
            resolve(list)
          } else {
            resolve(PAY_WAY)
          }
        }).catch(err => {
          resolve(PAY_WAY)
        })
      } else {
        resolve(session.get('PAY_WAY'))
      }
    })
  }
  //获取所有的场馆
  static getDeptListDTO() {
    return new Promise((resolve, reject) => {
      deptList().then(res => {
        if (res.code == 200 && !_.isEmpty(res.rows)) {
          let arr = res.rows.map(val => {
            return {
              label: val.deptName,
              value: val.deptId
            }
          })
          resolve(arr)
        } else {
          resolve([])
        }
      }).catch(err => {
        reject([])
      })
    })
  }

  //久医联数据处理
  static handleOldData(old) {
    if (isNull(old)) return
    let time = moment('2024-03-17').valueOf('start')
    let oldTime = moment(old).valueOf()
    return oldTime < time
  }
  //通过字符串获取诊断code
  static diagnoseListByName(obj) {
    return new Promise((resolve, reject) => {
      getDiagnoses(obj).then(res => {
        resolve(res)
      }).catch(err => {
        reject()
      })
    })
  }
  //日志记录
  static saveLogDTO(obj) {
    return new Promise((resolve, reject) => {
      saveLog(obj).then(res => {
        resolve(res)
      }).catch(err => {
        reject()
      })
    })
  }
  static getDictOptions(value) {
    return new Promise((resolve, reject) => {
      getOption({ 'code_type': value }).then(res => {
        if (res.code == 200) {
          resolve(res.data || [])
        }else{
          resolve([])
        }
      }).catch(err => {
        resolve([])
      })
    })
  }
  static getSourceConfig() {
    return new Promise((resolve, reject) => {
      if (isNull(session.get('sourceConfigList'))) {
        getSourceConfig({type: 2}).then(res => {
          if (res.code == 200) {
            session.set('sourceConfigList', res.data || [])
            resolve(res.data || [])
          } else {
            resolve([])
          }
        }).catch(err => {
          resolve([])
        })
      } else {
        resolve(session.get('sourceConfigList'))
      }
    })
  }
}
export { CommonDTO }